export const LOCAL_KEY_LANG_SETTING = "LOCAL_KEY_LANG_SETTING";
export const LOCAL_KEY_SUPPLIER_SHOP_LIST = "LOCAL_KEY_SUPPLIER_SHOP_LIST";

// PagePopupLayout
export const SESSION_KEY_PAGE_POPUP_PUSHED_KEYS =
  "SESSION_KEY_PAGE_POPUP_PUSHED_KEYS";

// 订单确认页会话信息
export const SESSION_KEY_IS_ROUTE_FROM_CONFIRM_ORDER_PAGE =
  "SESSION_KEY_IS_ROUTE_FROM_CONFIRM_ORDER_PAGE";
export const SESSION_KEY_CUSTOMER_REMARK = "SESSION_KEY_CUSTOMER_REMARK";
export const SESSION_KEY_SELECTED_PAYMENT_METHOD =
  "SESSION_KEY_SELECTED_PAYMENT_METHOD";
export const SESSION_KEY_IS_PRIVACY_POLICY_CHECKED =
  "SESSION_KEY_IS_PRIVACY_POLICY_CHECKED";
export const SESSION_KEY_IS_USER_TERMS_CHECKED =
  "SESSION_KEY_IS_USER_TERMS_CHECKED";
export const SESSION_KEY_CART_COUPON = "SESSION_KEY_CART_COUPON";
export const SESSION_KEY_CART_VOUCHER_CODE_DETAIL =
  "SESSION_KEY_CART_VOUCHER_CODE_DETAIL";
export const SESSION_KEY_CART_VOUCHER_CODE = "SESSION_KEY_CART_VOUCHER_CODE";
export const SESSION_KEY_CART_POINTS = "SESSION_KEY_CART_POINTS";
